/**
 *
 *  ? url pada submenu menggunakana naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */
export default [
  {
    icon: "PaperclipIcon",
    menu: "MoU",
    url: "kerjasama-mou",
  },
  {
    icon: "PaperclipIcon",
    menu: "MoA",
    url: "kerjasama-moa",
  },
  {
    icon: "PaperclipIcon",
    menu: "IA",
    url: "kerjasama-ia",
  },
  {
    icon: "BarChartIcon",
    menu: "Reporting",
    url: "kerjasama-reporting",
  },
];
